import React from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';
import API from '../../utils/Api';
const GeneratePassword = (props) => {
  const myApi = new API({});
  myApi.createEntity({ name: 'user' });
  const [form] = Form.useForm();
  
  let { token } = useParams(); //getting token from url, gets anything after the slash
  const onFinish = (values) => {
    const { history } = props;
    myApi.endpoints.user
      .update({ password: values.password, token }, {}, 'update-password')
      .then(notification.success({ message: 'Updated successfully.' }))
      .then(history.push('/'));
  };
  return (
    <div className='error-container'>
      <div>
        <div className='text-center'>
        </div>
        <h2>Create New Password</h2>
        <p>Enter your new password below.</p>
        <Form form={form} layout='vertical' onFinish={onFinish}>
          <Form.Item
            name='password'
            label='Password'
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name='confirm'
            label='Repeat Password'
            dependencies={['password']}
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Please confirm your password!',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    'The two passwords that you entered do not match!'
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item style={{ 'margin-bottom': 0 }}>
            <input type='hidden' name='_csrf' value='<%= csrfToken %>' />
            <input type='hidden' name='userID' value='<%= userID%>' />
            <Button htmlType='submit' type='primary'>
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default GeneratePassword;
